import React, {useEffect, useState} from "react";
import {Link, useNavigate, useLocation} from "react-router-dom";
import axios from "axios";
import logo from "../../assets/media/logos/logo.svg";
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";
import Button from "../Buttons/Button";
import {useSelector, useDispatch} from "react-redux";
import $ from 'jquery';

export default function () {
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotificationMenu, setShowNotificationMenu] = useState(false);
  const user = useSelector(state => state.user);
  const [notifications, setNotifications] = useState([]);
  const notificationsCount = useSelector(state => state.notificationCount);
  const menuOpen = useSelector(state => state.menuOpenClose);
  const dispatch = useDispatch();

  useEffect(() => {
    $(`.d-flex.flex-stack, #kt_content, #kt_aside, .header-brand, .topbar .title-breadcrumbs, table.dataTable tbody, table.dataTable thead tr:first-child,
    .dataTables_wrapper .row:nth-child(3), .dataTables_wrapper .row:nth-child(1) div:nth-child(2)`).click(function () {
      setShowNotificationMenu(false);
    });
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      getHeaderNotifications()
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const getHeaderNotifications = () => {
    axios.get('take-several-notifications/10').then(res => {
      dispatch({type: 'PUT_NOTIFICATION', count: res?.data?.notifications_data?.not_read_count});
      setNotifications(res?.data?.notifications_data?.notifications);
    });
  }

  const logOut = () => {
    axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
    axios.post('/logout')
      .then(
        localStorage.removeItem('persist:root'),
        navigate('/login')
      );
  }

  const editMyProfile = () => {
    navigate('/profile/edit');
  }

  const renderNotifications = (notificationsArray) => {
    return notificationsArray.map((notification, index) =>
      <>
        <div
          key={index}
          className={`notification${notification?.is_read == false ? " new" : ""}`}
          onClick={(e) => {
            navigate("/notifications/" + notification?.id);
            setShowNotificationMenu(false);
            if (e.currentTarget.classList.contains('new')) {
              e.currentTarget.classList.remove('new');
            }
          }}>
          <div className="d-flex flex-stack p-4">
            <div className="d-flex w-28-rem">
              <div className="symbol symbol-35px me-4">
                <span className="symbol-label bg-light-primary mt-1">
                  {notification?.notification_type_id == 1 ?
                    <i className="fas fa-shopping-cart text-primary fs-2"></i> :
                    <i className="fas fa-bell text-primary fs-2"></i>}
                </span>
              </div>
              <div className="mb-0 me-2 w-100">
                <div href="#"
                     className="fs-6 text-gray-800 fw-bolder ellipsis w-100 d-block w-25-rem">{notification?.template?.title}</div>
                <div className="text-gray-500 fs-7 ellipsis w-24-rem">{notification?.message}</div>
              </div>
            </div>
            <div className="badge badge-light fs-8">
              <span className="d-block mb-2">
                {new Date(notification?.created_at).getHours() < 10 ? '0' : '' + new Date(notification?.created_at).getHours()}
                {" : "}
                {new Date(notification?.created_at).getMinutes() < 10 ? '0' : '' + new Date(notification?.created_at).getMinutes()}
              </span>
              <span className="d-block">{new Date(notification?.created_at).toLocaleDateString('en-GB')}</span>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <div id="kt_header" className="header align-items-stretch">
      {/*begin::Brand*/}
      <div className="header-brand z-index-1000">
        {/*begin::Logo*/}
        <Link className="menu-link" to="/">
          <img alt="Logo" src={logo} className="h-25px"/>
          <h2 className="text-primary mt-1 ls-1">Admin Panel</h2>
        </Link>
        {/*end::Logo*/}
        {/*begin::Aside action*/}
        <div className="d-none d-lg-block">
          <button className="btn btn-icon btn-color-gray-500 w-auto px-0 btn-active-color-primary"
                  data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-placement="bottom-start"
                  data-kt-menu-overflow="true">
            {/*begin::Svg Icon | path: icons/duotune/coding/cod001.svg*/}
            {/* <i className="fas fa-cog"></i> */}
            {/*end::Svg Icon*/}
          </button>
          {/*begin::Menu 3*/}
          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
            data-kt-menu="true">
            {/*begin::Heading*/}
            <div className="menu-item px-3">
              <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">Payments</div>
            </div>
            {/*end::Heading*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3">
              <a href="#" className="menu-link px-3">Create Invoice</a>
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3">
              <a href="#" className="menu-link flex-stack px-3">Create Payment
                <i className="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip"
                   title="Specify a target name for future usage and reference"/></a>
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3">
              <a href="#" className="menu-link px-3">Generate Bill</a>
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-end">
              <a href="#" className="menu-link px-3">
                <span className="menu-title">Subscription</span>
                <span className="menu-arrow"/>
              </a>
              {/*begin::Menu sub*/}
              <div className="menu-sub menu-sub-dropdown w-175px py-4">
                {/*begin::Menu item*/}
                <div className="menu-item px-3">
                  <a href="#" className="menu-link px-3">Plans</a>
                </div>
                {/*end::Menu item*/}
                {/*begin::Menu item*/}
                <div className="menu-item px-3">
                  <a href="#" className="menu-link px-3">Billing</a>
                </div>
                {/*end::Menu item*/}
                {/*begin::Menu item*/}
                <div className="menu-item px-3">
                  <a href="#" className="menu-link px-3">Statements</a>
                </div>
                {/*end::Menu item*/}
                {/*begin::Menu separator*/}
                <div className="separator my-2"/>
                {/*end::Menu separator*/}
                {/*begin::Menu item*/}
                <div className="menu-item px-3">
                  <div className="menu-content px-3">
                    {/*begin::Switch*/}
                    <label className="form-check form-switch form-check-custom form-check-solid">
                      {/*begin::Input*/}
                      <input className="form-check-input w-30px h-20px" type="checkbox" defaultValue={1}
                             defaultChecked="checked" name="notifications"/>
                      {/*end::Input*/}
                      {/*end::Label*/}
                      <span className="form-check-label text-muted fs-6">Recuring</span>
                      {/*end::Label*/}
                    </label>
                    {/*end::Switch*/}
                  </div>
                </div>
                {/*end::Menu item*/}
              </div>
              {/*end::Menu sub*/}
            </div>
            {/*end::Menu item*/}
            {/*begin::Menu item*/}
            <div className="menu-item px-3 my-1">
              <a href="#" className="menu-link px-3">Settings</a>
            </div>
            {/*end::Menu item*/}
          </div>
          {/*end::Menu 3*/}
        </div>
        {/*end::Aside action*/}
        {/*begin::Aside toggle*/}
        <div className="d-flex align-items-center d-lg-none ms-n3 me-1" title="Show aside menu">
          <div className="btn btn-icon btn-active-color-primary w-30px h-30px" id="kt_aside_mobile_toggle">
            {/*begin::Svg Icon | path: icons/duotune/abstract/abs015.svg*/}
            <i className="fas fa-cog"></i>
            {/*end::Svg Icon*/}
          </div>
        </div>
        {/*end::Aside toggle*/}
      </div>
      {/*end::Brand*/}
      {/*begin::Topbar*/}
      <div className="topbar z-index-999">
        {/*begin::Topbar container*/}
        <div className="h-100 w-100">
          {/*begin::Page title*/}
          <div className={`h-100 d-inline-block py-8 pl-3 w-auto title-breadcrumbs${menuOpen? "" : " with-closed-menu "} hover-bg-none`}>
            {/*begin::Title*/}
            <Link className="menu-link d-lg-none hover-bg-none" to="/">
              <img alt="Logo" src={logo} className="h-25px hover-bg-none"/>
              <h2 className="logo-text text-primary mt-1 ls-1 hover-bg-none">Admin Panel</h2>
            </Link>
            <h1 className="d-inline-block ls-1 hover-bg-none" id="pageTitle">Home</h1>
            <span className="mx-2 ls-1 hover-bg-none" id="breadcrumbs">
              {/* bh */}
            </span>
            {/*end::Title*/}
            {/*begin::Breadcrumb*/}
            {/*end::Breadcrumb*/}
          </div>
          <div
            id="profile-division"
            className="profile-division d-inline-block float-right w-auto"
          >
            <div className="notification-div">
              <button
                className="btn-notification-toggle"
                onClick={() => {
                  getHeaderNotifications()
                  setShowNotificationMenu(!showNotificationMenu);
                  setShowUserMenu(false);
                }}
              >
                {showNotificationMenu ? <i className="fas fa-times-circle text-primary"></i> :
                  <i className="fas fa-bell text-primary"></i>}
                <div className="notification-count-div" id="notifications_count_div">
                  {notificationsCount > 0 &&
                  <div className="notification-count" id="notifications_count">
                    {notificationsCount < 100 ? notificationsCount : '99+'}
                  </div>
                  }
                </div>
              </button>
              <div className={`notifications-list${!showNotificationMenu ? " " + "d-none" : ''}`}>
                {notifications.length !== 0 &&
                <div className="see-all-div">
                  <div className="see-all-middle">
                    <button
                      className="btn btn-primary mb-7 see-all"
                      onClick={() => {
                        navigate('/notifications');
                        setShowNotificationMenu(false)
                      }}
                    >
                      See all notifications
                    </button>
                  </div>
                </div>
                }
                <div>
                  {notifications && (renderNotifications(notifications))}
                </div>

                {!notifications.length && (
                  <h6 className="text-center my-10"><i className="fas fa-bell-slash fs-1 mr-3"></i>You have not
                    notifications</h6>
                )}
              </div>
            </div>

            <div
              className="h-100 d-flex align-items-center cursor-pointer"
              onClick={() => {
                setShowUserMenu(!showUserMenu)
                setShowNotificationMenu(false);
              }}
            >
              <div className="user-img"
                   style={{
                     backgroundImage:
                       `url(${user?.avatar ? user?.avatar : avatarBlank})`
                   }}>
              </div>
              <h5 className="user-email d-inline-block">
                {user?.email}
              </h5>
            </div>
            <div className={`user-menu${!showUserMenu ? " " + "d-none" : ''}`}>
              <ul className="li-style-none mb-0 px-0">
                <li className="border-bottom">
                  <Button
                    title="Edit My Profile"
                    classes="btn-light mb-3"
                    action={editMyProfile}
                  />
                </li>
                <li className="mt-3">
                  <Button
                    title="Log Out"
                    classes="btn-light"
                    action={logOut}
                  />
                </li>
              </ul>
            </div>
          </div>
          {/*end::Page title*/}
          {/*begin::Action group*/}
          {/*end::Action group*/}
        </div>
        {/*end::Topbar container*/}
      </div>
      {/*end::Topbar*/}
    </div>
  );
}